module.exports = __webpack_public_path__ + "static/media/BCH.ae6dda56.svg";